<template>
  <!-- <img v-if="isHilfy" src="@/assets/images/onGreen.svg" alt="logo" /> -->
  <svg
    v-if="isHilfy"
    width="60"
    height="30"
    viewBox="0 0 60 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.38518 21.4695H0.563606C0.187543 21.4695 -0.000488281 21.2811 -0.000488281 20.9039V1.24205C-0.000488281 0.864859 0.187543 0.676025 0.563606 0.676025H4.38518C4.74235 0.676025 4.92093 0.864859 4.92093 1.24205V8.76651H11.2776V1.24205C11.2776 0.864859 11.4657 0.676025 11.8422 0.676025H15.6633C16.0394 0.676025 16.2279 0.864859 16.2279 1.24205V20.9039C16.2279 21.2811 16.0394 21.4695 15.6633 21.4695H11.8422C11.4657 21.4695 11.2776 21.2811 11.2776 20.9039V13.7254H4.92093V20.9039C4.92093 21.2811 4.74235 21.4695 4.38518 21.4695Z"
      fill="var(--menu-text-color)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.2645 21.4695H19.5299C19.1539 21.4695 18.9658 21.2811 18.9658 20.9039V8.62548C18.9658 8.24875 19.1539 8.05992 19.5299 8.05992H23.2645C23.6411 8.05992 23.8291 8.24875 23.8291 8.62548V20.9039C23.8291 21.2811 23.6411 21.4695 23.2645 21.4695Z"
      fill="var(--menu-text-color)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.7909 21.4694H27.0563C26.6802 21.4694 26.4917 21.2811 26.4917 20.9039V1.2581C26.4917 0.881384 26.6802 0.692551 27.0563 0.692551H30.7909C31.1575 0.692551 31.3408 0.881384 31.3408 1.2581V20.9039C31.3408 21.2811 31.1575 21.4694 30.7909 21.4694Z"
      fill="var(--menu-text-color)"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="45"
      y="8"
      width="15"
      height="22"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.1851 8.03265H59.9785V29.1756H45.1851V8.03265Z"
        fill="var(--menu-text-color)"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59.4428 8.03265H55.6794C55.3676 8.03265 55.1148 8.28538 55.1148 8.59773V14.3858C55.1148 15.1108 54.881 15.7247 54.4128 16.2268C53.9446 16.7299 53.3101 16.9807 52.5093 16.9807C51.6991 16.9807 51.0858 16.7053 50.671 16.1549C50.2562 15.604 50.0488 14.8879 50.0488 14.0086V8.59773C50.0488 8.28538 49.7961 8.03265 49.4843 8.03265H45.7208C45.3636 8.03265 45.1851 8.22101 45.1851 8.59773V14.9802C45.1851 17.1165 45.6651 18.7545 46.6255 19.8956C48.0759 21.6187 50.7301 22.2292 52.9047 21.7636C53.6602 21.6296 54.511 21.3655 55.1748 20.852C55.1413 21.7721 54.9088 22.711 54.3551 23.4261C53.7112 24.2577 52.5452 24.5497 51.5399 24.5497C50.3805 24.5497 49.189 24.1654 48.3551 23.332C48.2588 23.2359 48.1619 23.1871 48.066 23.1871C47.921 23.1871 47.7906 23.2742 47.6748 23.4479L45.7496 26.0291C45.5469 26.2809 45.5564 26.5175 45.7784 26.7395C46.4058 27.4551 47.2501 28.0395 48.3117 28.4939C49.3732 28.9482 50.4877 29.1759 51.6556 29.1759C54.1255 29.1759 56.1603 28.475 57.6995 26.871C59.2387 25.2662 59.9786 23.1053 59.9786 20.5917V8.59773C59.9786 8.22101 59.8 8.03265 59.4428 8.03265Z"
        fill="var(--menu-text-color)"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.3842 2.62427C44.7568 1.90916 43.9126 1.32468 42.851 0.870341L42.8491 0.87602C41.9288 0.470904 41.2518 0.437776 40.4732 0.465225C38.882 0.52249 37.639 1.04971 36.7177 1.96359C35.796 2.87604 35.3354 4.11174 35.3354 5.66832V8.03276H33.8155C33.4584 8.03276 33.2798 8.22064 33.2798 8.59784V11.9187C33.2798 12.2959 33.4584 12.4838 33.8155 12.4838H35.3354V20.9037C35.3354 21.2809 35.5092 21.4693 35.8565 21.4693H39.62C39.996 21.4693 40.1845 21.2809 40.1845 20.9037V12.4838H42.7754C43.1226 12.4838 43.2965 12.2959 43.2965 11.9187V8.59784C43.2965 8.22064 43.1226 8.03276 42.7754 8.03276H40.1845V6.85669C40.1845 6.26747 40.3149 5.84721 40.5748 5.59543C41.2948 4.90021 42.362 5.21635 42.9592 5.88034C43.056 5.97641 43.1529 6.02516 43.2488 6.02516C43.3938 6.02516 43.5242 5.93761 43.64 5.76439L45.413 3.33464C45.6157 3.08381 45.6063 2.84718 45.3842 2.62427Z"
      fill="var(--menu-text-color)"
    />
    <mask
      id="mask1"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="18"
      y="0"
      width="6"
      height="6"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.8633 0.0834808H23.7136V5.43612H18.8633V0.0834808Z"
        fill="var(--menu-text-color)"
      />
    </mask>
    <g mask="url(#mask1)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.1414 5.43612C23.4613 5.43612 23.7187 5.17298 23.7135 4.85353C23.7008 4.04613 23.6913 3.2837 23.6928 2.76027C23.6937 2.40153 23.6753 0.0910475 23.4102 0.102879C23.1868 0.114238 22.8069 0.656601 22.4871 1.31207C22.4871 1.2993 20.1202 1.33432 20.1202 1.33432C19.9482 1.04847 19.4536 0.00254671 19.1304 0.0882079C18.7917 0.179548 18.8465 2.76406 18.9136 4.88098C18.923 5.19049 19.1762 5.43612 19.4852 5.43612H23.1414Z"
        fill="#ED7317"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.3669 3.54492H18.1337C18.0926 3.54492 18.0591 3.51132 18.0591 3.47015C18.0591 3.42897 18.0926 3.39584 18.1337 3.39584H20.3669C20.4081 3.39584 20.4416 3.42897 20.4416 3.47015C20.4416 3.51132 20.4081 3.54492 20.3669 3.54492Z"
      fill="var(--menu-text-color)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.3669 3.54492H18.1337C18.0926 3.54492 18.0591 3.51132 18.0591 3.47015C18.0591 3.42897 18.0926 3.39584 18.1337 3.39584H20.3669C20.4081 3.39584 20.4416 3.42897 20.4416 3.47015C20.4416 3.51132 20.4081 3.54492 20.3669 3.54492Z"
      stroke="white"
      stroke-width="0.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1763 4.64765C18.1437 4.64765 18.1139 4.62635 18.105 4.59369C18.0936 4.55394 18.1163 4.51277 18.156 4.50093L20.3032 3.88664C20.3424 3.87528 20.384 3.89799 20.3949 3.93775C20.4062 3.9775 20.3835 4.01868 20.3438 4.02956L18.1966 4.64481C18.19 4.6467 18.1829 4.64765 18.1763 4.64765Z"
      fill="var(--menu-text-color)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1763 4.64765C18.1437 4.64765 18.1139 4.62635 18.105 4.59369C18.0936 4.55394 18.1163 4.51277 18.156 4.50093L20.3032 3.88664C20.3424 3.87528 20.384 3.89799 20.3949 3.93775C20.4062 3.9775 20.3835 4.01868 20.3438 4.02956L18.1966 4.64481C18.19 4.6467 18.1829 4.64765 18.1763 4.64765Z"
      stroke="white"
      stroke-width="0.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.2464 3.53755C22.2181 3.53755 22.1911 3.52193 22.1789 3.49401C22.1614 3.45662 22.1779 3.41214 22.2152 3.3951L24.2453 2.46324C24.2831 2.44573 24.3271 2.46276 24.3441 2.50015C24.3615 2.53801 24.345 2.58155 24.3077 2.59906L22.2776 3.53093C22.2672 3.53519 22.2568 3.53755 22.2464 3.53755Z"
      fill="var(--menu-text-color)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.2464 3.53755C22.2181 3.53755 22.1911 3.52193 22.1789 3.49401C22.1614 3.45662 22.1779 3.41214 22.2152 3.3951L24.2453 2.46324C24.2831 2.44573 24.3271 2.46276 24.3441 2.50015C24.3615 2.53801 24.345 2.58155 24.3077 2.59906L22.2776 3.53093C22.2672 3.53519 22.2568 3.53755 22.2464 3.53755Z"
      stroke="white"
      stroke-width="0.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.4472 4.10187C22.4066 4.10187 22.3735 4.06969 22.3726 4.02899C22.3721 3.98782 22.4047 3.95374 22.4458 3.95327L24.6356 3.91351C24.6743 3.91304 24.7107 3.94522 24.7116 3.9864C24.7121 4.02804 24.6795 4.06117 24.6384 4.06212L22.4486 4.10187H22.4472Z"
      fill="var(--menu-text-color)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.4472 4.10187C22.4066 4.10187 22.3735 4.06969 22.3726 4.02899C22.3721 3.98782 22.4047 3.95374 22.4458 3.95327L24.6356 3.91351C24.6743 3.91304 24.7107 3.94522 24.7116 3.9864C24.7121 4.02804 24.6795 4.06117 24.6384 4.06212L22.4486 4.10187H22.4472Z"
      stroke="white"
      stroke-width="0.3"
    />
  </svg>

  <svg
    v-else
    width="76"
    height="32"
    viewBox="0 0 76 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 23.2441V0.706633C0 0.274731 0.234447 0.117676 0.586118 0.117676H9.26067C13.7933 0.117676 16.5285 3.53363 16.5285 7.65633C16.5285 11.5042 13.5589 15.2735 9.26067 15.2735H5.27506V23.2833C5.27506 23.7152 5.07969 23.8723 4.68895 23.8723H0.586118C0.156298 23.8723 0 23.6367 0 23.2441ZM11.2535 7.65633C11.2535 5.85019 10.0812 4.90786 8.01028 4.90786H5.27506V10.4441H8.01028C10.0422 10.4441 11.2535 9.4232 11.2535 7.65633Z"
      fill="var(--menu-text-color)"
    />
    <path
      d="M23.5228 8.52021V10.2478H23.5619C24.148 8.99138 25.6329 7.57788 27.4303 7.57788C28.1727 7.57788 29.1105 7.65641 29.892 8.12757C30.2437 8.36316 30.1655 8.638 30.0874 9.03064L28.9933 12.7607C28.8761 13.0355 28.6416 13.1533 28.2118 12.9963C27.7429 12.8 27.274 12.7214 26.8051 12.7214C24.9686 12.7214 23.4838 14.0957 23.4838 16.6478V23.2441C23.4838 23.676 23.2884 23.8331 22.8976 23.8331H18.912C18.4822 23.8331 18.3259 23.6368 18.3259 23.2441C18.3259 17.9043 18.3259 13.8208 18.3259 8.48095C18.3259 8.04905 18.5213 7.89199 18.912 7.89199H22.8976C23.3665 7.89199 23.5228 8.2061 23.5228 8.52021Z"
      fill="var(--menu-text-color)"
    />
    <path
      d="M57.7522 5.4184C57.1661 5.14356 56.6972 4.9865 56.1501 4.9865C55.4077 4.9865 54.7044 5.37914 54.7044 6.75337V7.93129H57.4787C57.8694 7.93129 58.0648 8.12761 58.0648 8.52024V12.0933C58.0648 12.4859 57.8694 12.6822 57.4787 12.6822H54.7044V23.2442C54.7044 23.6761 54.4699 23.8331 54.1182 23.8331H50.0936C49.7028 23.8331 49.5074 23.6368 49.5074 23.2442V12.6822H47.9054C47.5146 12.6822 47.3193 12.4466 47.3193 12.0933V8.52024C47.3193 8.08834 47.5146 7.93129 47.9054 7.93129H49.5074V5.49693C49.4684 2.15951 51.5784 0 54.9779 0C56.7362 0 58.2992 0.588957 59.8231 1.64908C60.1748 1.92393 60.0966 2.08098 59.9403 2.39509L58.2601 5.33988C58.1429 5.5362 58.0257 5.57546 57.7522 5.4184Z"
      fill="var(--menu-text-color)"
    />
    <path
      d="M67.091 32.0001C64.5121 32.0001 62.0895 30.8614 60.8 29.3694C60.5265 29.0945 60.5265 28.8982 60.7609 28.5841L62.8319 25.7964C63.1054 25.443 63.3008 25.443 63.5743 25.6786C64.3558 26.4639 65.5671 26.9743 66.9738 26.9743C69.9434 26.9743 70.8031 25.0111 70.8031 23.2835V21.7129C70.1388 22.8123 68.0679 23.8332 66.1141 23.8332C62.363 23.8332 60.1748 21.281 60.1748 16.7264V8.48105C60.1748 8.08841 60.4093 7.89209 60.7609 7.89209H64.7856C65.2154 7.89209 65.3717 8.16694 65.3717 8.48105V15.7056C65.3717 17.5117 66.1923 18.886 68.0288 18.886C69.7871 18.886 70.8422 17.5902 70.8422 16.0982V8.52031C70.8422 8.12767 71.0375 7.93135 71.4283 7.93135H75.4529C75.8437 7.93135 76.0391 8.16694 76.0391 8.52031V22.7731C76 28.1522 72.4442 32.0001 67.091 32.0001Z"
      fill="var(--menu-text-color)"
    />
    <path
      d="M38.254 7.57788C33.6823 7.57788 30.0483 11.2687 30.0483 15.8625C30.0483 20.4564 33.6823 24.1472 38.254 24.1472C42.8257 24.1472 46.4987 20.4564 46.4987 15.8625C46.4987 11.2687 42.8257 7.57788 38.254 7.57788ZM43.1383 18.0221C43.1383 18.1006 43.0602 18.1791 43.0211 18.2184C42.982 18.2576 42.9039 18.2969 42.8257 18.2969C42.8257 18.2969 42.8257 18.2969 42.7866 18.2969C42.7866 18.2969 42.7866 18.2969 42.7476 18.2969L41.1455 18.0221C40.7157 19.0822 39.7388 19.5141 38.1758 19.5141C36.7692 19.5141 35.7142 19.0429 35.2843 17.8257L33.7995 18.1398C33.6432 18.1398 33.526 18.0221 33.4869 17.865C33.4869 17.7865 33.4869 17.7079 33.526 17.6294C33.5651 17.5509 33.6432 17.5116 33.7213 17.4724L35.128 17.1975C35.089 16.9619 35.089 16.7656 35.089 16.4908C35.089 16.4515 35.089 16.4122 35.089 16.373L33.8776 16.2944C33.7995 16.2944 33.7213 16.2552 33.6432 16.1767C33.6041 16.0981 33.5651 16.0196 33.5651 15.9411C33.5651 15.7448 33.7213 15.627 33.9167 15.627L35.089 15.7055C35.0499 13.3104 34.9717 11.7398 35.3625 11.6221C35.7923 11.5043 36.4566 12.8785 36.6519 13.2711C36.6519 13.2711 37.3553 13.0356 38.1758 13.0356C39.0355 13.0356 39.7388 13.2319 39.7388 13.2319C40.1686 12.3681 40.6766 11.6613 40.9501 11.6613C41.2237 11.6613 41.3409 14.2135 41.3409 15.7055L42.5913 15.3914C42.6694 15.3521 42.7476 15.3914 42.8257 15.4306C42.9039 15.4699 42.9429 15.5484 42.982 15.627C43.0211 15.7055 42.982 15.784 42.9429 15.8625C42.9039 15.9411 42.8257 15.9803 42.7476 16.0196L41.3409 16.373C41.3409 16.4122 41.3409 16.4515 41.3409 16.4908C41.3409 16.8049 41.3018 17.119 41.2627 17.3938L42.7866 17.6294C43.0602 17.7079 43.1774 17.865 43.1383 18.0221Z"
      fill="var(--menu-text-color)"
    />
  </svg>
</template>

<script>
export default {
    computed: {
        isHilfy() {
            return this.$config.behavior === 'hilfy'
        },
    },
}
</script>
